<template>
  <div>
    <div style="width: 100%;">
      <div id="line">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    list7: Object
  },
  name: "",
  data () {
    return {

    }
  },
  created () {
  },
  mounted () {
    this.line()
  },
  methods: {
    line () {
      let chartDom = document.getElementById('line');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color:["#73c0de","#ee6666"],
        title: {
          text: '当月添加客资数与成单客资数'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['成单客资数据', '添加客资数据']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.list7.hourList||this.list7.dayList||this.list7.monthList
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '成单客资数据',
            type: 'line',
            stack: 'Total1',
            data: this.list7.orderTotal
          },
          {
            name: '添加客资数据',
            type: 'line',
            stack: 'Total2',
            data: this.list7.addTotal
          },




        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    }
  },
  watch: {
    list7: {
      deep: true,
      handler (val) {
        this.line()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped>
#line {
  position: relative;
  width: 100%;
  height: 400px;
  padding: 0px;
  margin: 0px;
  top: 10px;
  border-width: 0px;
  display: flex;
}
</style>




// WEBPACK FOOTER //
// src/statistics/components/linechart.vue